var _defs, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _text, _text2, _text3, _text4, _rect66, _rect67, _path2, _rect68, _path3, _path4, _path5, _path6, _path7, _path8, _rect69, _polygon, _path9, _rect70, _polygon2, _polygon3, _polygon4, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeneme60X402(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180.16 114.14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #1d1d1b;\n      }\n\n      .cls-5 {\n        fill: #83559c;\n      }\n\n      .cls-6 {\n        fill: #1c1d1c;\n      }\n\n      .cls-2 {\n        font-size: 6.86px;\n      }\n\n      .cls-2, .cls-4 {\n        font-family: Helvetica, Helvetica;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-7 {\n        fill: none;\n        stroke: #00fe00;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .cls-4 {\n        font-size: 7px;\n      }"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 156.53,
    y: 43.28,
    width: 2.83,
    height: 28.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.05,53.84c-.22.25-.48.37-.8.37s-.59-.12-.82-.37-.34-.58-.34-.99c0-.46.12-.83.36-1.1s.51-.41.81-.41.55.13.77.39c.22.26.34.61.34,1.07s-.11.8-.33,1.05M117,56.74c.29.27.66.4,1.1.4.39,0,.73-.11,1.05-.33.31-.22.56-.57.74-1.05.18-.48.27-1.15.27-2.02,0-.78-.08-1.37-.25-1.79-.17-.41-.41-.73-.72-.94-.31-.21-.64-.32-1-.32-.5,0-.93.19-1.29.57-.35.38-.53.9-.53,1.56s.17,1.14.51,1.51.74.55,1.21.55c.26,0,.51-.07.76-.22.25-.15.45-.35.59-.61v.16c0,.49-.07.93-.2,1.3-.13.37-.3.63-.49.77s-.41.22-.64.22c-.53,0-.85-.33-.96-1l-.68.07c.06.51.23.9.53,1.17M109.85,54.81l1.8-2.85v2.85h-1.8ZM112.36,57.03v-1.51h.78v-.71h-.78v-4.09h-.58l-2.62,4.09v.71h2.49v1.51h.71ZM102.98,56.66c.34.32.76.48,1.25.48.53,0,.98-.18,1.36-.55.38-.37.57-.84.57-1.42,0-.27-.05-.52-.14-.74-.09-.22-.21-.4-.36-.53-.15-.13-.34-.23-.57-.28.25-.13.44-.3.58-.52.14-.22.21-.47.21-.76,0-.47-.16-.86-.49-1.17-.32-.31-.72-.46-1.19-.46s-.82.14-1.13.41c-.31.28-.51.68-.6,1.22l.7.14c.05-.38.17-.67.36-.85.19-.19.42-.28.69-.28s.48.09.67.27c.18.18.27.42.27.71,0,.32-.11.58-.33.77-.22.19-.5.29-.85.29h-.11s-.08.67-.08.67c.2-.06.36-.09.5-.09.32,0,.58.11.8.34.22.22.33.52.33.89,0,.39-.12.71-.36.95-.24.25-.52.37-.84.37-.6,0-.97-.42-1.12-1.24l-.7.1c.05.54.24.97.58,1.3M98.07,50.69h-.46c-.12.28-.33.56-.63.85-.3.29-.64.54-1.03.74v.75c.23-.09.48-.23.76-.41.27-.18.49-.35.66-.53v4.94h.71v-6.34ZM89,56.67c.34.31.76.47,1.26.47.6,0,1.08-.22,1.43-.66.35-.44.53-.97.53-1.59s-.18-1.12-.53-1.49c-.36-.37-.77-.55-1.26-.55-.38,0-.74.13-1.09.4l.31-1.7h2.3v-.74h-2.86l-.56,3.24.67.09c.11-.19.26-.34.44-.45.19-.11.39-.16.6-.16.35,0,.65.12.88.37.23.25.35.6.35,1.05,0,.48-.12.86-.36,1.14-.24.28-.53.42-.87.42-.27,0-.5-.1-.71-.3-.2-.2-.33-.5-.39-.9l-.74.07c.05.55.24.98.59,1.29M82.33,56.29c.08-.14.18-.28.3-.42.12-.14.4-.41.82-.79.66-.61,1.11-1.11,1.35-1.48.24-.37.35-.75.35-1.16,0-.45-.15-.86-.45-1.21-.3-.36-.75-.53-1.33-.53-.54,0-.97.15-1.3.46-.33.31-.52.76-.57,1.37l.73.08c0-.41.11-.72.32-.94.21-.22.48-.33.81-.33.31,0,.56.1.77.3.21.2.31.46.31.79,0,.28-.1.58-.31.9-.2.32-.64.78-1.3,1.37-.57.51-.95.95-1.16,1.32-.21.37-.31.71-.3,1.01h3.8v-.74h-2.82ZM77.1,50.69h-.46c-.12.28-.33.56-.63.85s-.64.54-1.03.74v.75c.23-.09.48-.23.76-.41.27-.18.49-.35.65-.53v4.94h.71v-6.34ZM70.13,53.84c-.22.25-.48.37-.8.37s-.59-.12-.82-.37c-.23-.25-.34-.58-.34-.99,0-.46.12-.83.36-1.1.24-.28.51-.41.81-.41s.55.13.77.39c.22.26.34.61.34,1.07s-.11.8-.33,1.05M68.08,56.74c.29.27.66.4,1.1.4.39,0,.74-.11,1.05-.33.31-.22.56-.57.74-1.05s.27-1.15.27-2.02c0-.78-.09-1.37-.25-1.79-.17-.41-.41-.73-.72-.94-.31-.21-.64-.32-1-.32-.5,0-.93.19-1.29.57-.35.38-.53.9-.53,1.56s.17,1.14.51,1.51.74.55,1.21.55c.26,0,.51-.07.76-.22.25-.15.45-.35.59-.61v.16c0,.49-.07.93-.2,1.3-.13.37-.3.63-.49.77-.19.15-.41.22-.64.22-.53,0-.85-.33-.96-1l-.68.07c.06.51.23.9.53,1.17M61.51,51.86c.22-.35.48-.53.8-.53.35,0,.63.17.85.52.22.35.33,1.04.33,2.06s-.11,1.7-.33,2.06c-.22.35-.49.53-.81.53-.34,0-.62-.17-.84-.52-.22-.35-.33-1.04-.33-2.06s.11-1.7.32-2.06M60.99,56.42c.35.48.8.72,1.35.72.62,0,1.09-.27,1.41-.82.32-.55.47-1.35.47-2.4,0-1.18-.19-2.03-.57-2.56-.32-.44-.75-.66-1.3-.66-.62,0-1.09.27-1.4.82-.32.55-.48,1.35-.48,2.41,0,1.18.17,2.02.52,2.5M54.06,56.66c.34.32.76.48,1.25.48.53,0,.98-.18,1.36-.55.38-.37.57-.84.57-1.42,0-.27-.05-.52-.14-.74-.09-.22-.21-.4-.36-.53-.15-.13-.34-.23-.57-.28.25-.13.44-.3.58-.52.14-.22.21-.47.21-.76,0-.47-.16-.86-.49-1.17-.33-.31-.72-.46-1.19-.46s-.82.14-1.13.41-.51.68-.6,1.22l.7.14c.05-.38.17-.67.36-.85.19-.19.42-.28.69-.28s.49.09.67.27c.18.18.27.42.27.71,0,.32-.11.58-.33.77-.22.19-.5.29-.85.29h-.11s-.08.67-.08.67c.2-.06.36-.09.5-.09.32,0,.58.11.8.34.22.22.32.52.32.89,0,.39-.12.71-.35.95-.24.25-.52.37-.84.37-.6,0-.97-.42-1.12-1.24l-.7.1c.05.54.24.97.58,1.3M46.95,54.81l1.8-2.85v2.85h-1.8ZM49.46,57.03v-1.51h.78v-.71h-.78v-4.09h-.58l-2.62,4.09v.71h2.49v1.51h.71ZM42.16,50.69h-.46c-.12.28-.33.56-.63.85-.3.29-.64.54-1.03.74v.75c.23-.09.48-.23.76-.41.27-.18.49-.35.66-.53v4.94h.71v-6.34ZM33.63,53.99c.23-.25.49-.37.8-.37s.58.12.8.37c.22.25.33.59.33,1.04s-.11.82-.33,1.08c-.22.26-.47.39-.74.39-.32,0-.59-.14-.83-.42-.24-.28-.36-.64-.36-1.1,0-.42.11-.75.34-1M35.63,51.1c-.3-.27-.66-.4-1.1-.4-.6,0-1.1.26-1.48.78-.38.52-.58,1.39-.58,2.61,0,1.1.19,1.89.57,2.36.38.47.86.71,1.43.71.32,0,.62-.08.89-.25s.49-.42.66-.76c.17-.34.26-.73.26-1.15,0-.62-.17-1.12-.51-1.49-.34-.37-.74-.56-1.19-.56-.27,0-.53.07-.78.21s-.45.35-.61.63c0-.78.11-1.36.33-1.76.25-.46.58-.69.99-.69.26,0,.49.1.68.3.13.14.23.37.3.69l.7-.06c-.06-.51-.24-.9-.54-1.17M25.99,54.81l1.8-2.85v2.85h-1.8ZM28.49,57.03v-1.51h.78v-.71h-.78v-4.09h-.58l-2.62,4.09v.71h2.49v1.51h.71Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 8.93,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 10.41,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 14.1,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 16.63,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 18.12,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 19.6,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.19,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 24.72,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 26.2,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.73,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.22,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 31.7,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 34.24,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 35.72,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 37.21,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 40.84,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 42.32,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 43.81,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 46.34,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 48.93,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.41,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 54.04,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 55.53,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 57.01,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 58.44,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 59.93,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 61.41,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 63.95,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 66.53,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 69.12,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 71.65,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 73.13,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 74.62,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.05,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 77.53,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.22,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 82.65,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 84.14,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 86.72,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 88.15,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 90.74,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 93.33,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 94.76,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 97.34,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 98.83,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.26,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 101.74,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 105.43,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 106.86,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 110.55,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 112.03,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 113.46,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 114.95,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 116.43,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 118.96,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 121.55,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 123.03,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 125.57,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 128.15,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 129.64,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131.07,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 132.55,
    y: 32.08,
    width: 1.65,
    height: 17.01
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 136.24,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 138.77,
    y: 32.08,
    width: 0.55,
    height: 17.01
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(9.41 71.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6868/001/800/12-18"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(9.41 81.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RUC 80089348-4"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(122.1 71.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "90/52"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(108.01 81.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RN 77302"))), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.25,
    y: 0.25,
    width: 179.66,
    height: 113.64
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 150.36,
    y: 0.25,
    width: 0.5,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m150.86 109.07h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.97h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.97h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.97h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98zm0-5.97h-0.5v-2.98h0.5v2.98zm0-5.96h-0.5v-2.98h0.5v2.98z"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 150.36,
    y: 112.05,
    width: 0.5,
    height: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.03,94.57h.45c.21,0,.36-.03.44-.1.08-.06.12-.15.12-.25l-.06-.18-.15-.12c-.07-.03-.19-.04-.37-.04h-.42v.69ZM70.67,95.85v-2.28h.78c.27,0,.46.02.58.06.12.04.21.12.29.22.07.1.11.22.11.33,0,.17-.06.31-.18.43-.12.12-.28.19-.47.21l.19.12c.09.09.2.24.34.45l.28.45h-.45l-.2-.36c-.16-.28-.29-.46-.38-.53-.07-.05-.17-.08-.29-.08h-.22v.97h-.37ZM71.6,92.92c-.3,0-.59.08-.87.23-.28.15-.5.37-.66.65-.16.29-.24.58-.24.89s.08.6.24.88c.16.28.38.5.65.65.28.16.57.23.88.23s.6-.08.88-.23c.28-.16.5-.38.65-.65.15-.28.23-.57.23-.88s-.08-.6-.24-.89c-.16-.28-.38-.5-.66-.65-.28-.15-.57-.23-.87-.23M71.6,92.57c.36,0,.7.09,1.04.27.34.18.6.44.79.78.19.34.28.69.28,1.06s-.09.72-.28,1.05c-.19.34-.45.6-.78.79-.33.19-.69.28-1.05.28s-.72-.09-1.05-.28c-.34-.19-.6-.45-.79-.79-.19-.34-.28-.69-.28-1.05s.1-.72.28-1.06c.19-.34.46-.6.79-.78.34-.18.69-.27,1.04-.27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.85,100.03l.7.1c.03.21.11.36.25.46.18.13.42.19.73.19.33,0,.59-.07.77-.19.18-.13.3-.31.37-.55.04-.14.05-.44.05-.9-.32.36-.71.54-1.18.54-.58,0-1.04-.2-1.36-.61-.32-.41-.48-.91-.48-1.48,0-.4.07-.76.22-1.09.15-.33.36-.59.64-.77.28-.18.61-.27.98-.27.5,0,.92.2,1.24.59v-.5h.67v3.58c0,.64-.07,1.1-.2,1.37-.13.27-.35.48-.64.64-.29.16-.65.23-1.08.23-.51,0-.92-.11-1.23-.33-.31-.22-.46-.56-.45-1M10.45,97.54c0,.54.11.94.33,1.19.22.25.5.37.83.37s.61-.12.83-.37c.22-.25.34-.64.34-1.17s-.11-.89-.35-1.15c-.23-.26-.51-.39-.83-.39s-.59.13-.82.38c-.23.25-.34.63-.34,1.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.54,99.69v-4.14h.65v.63c.16-.29.32-.49.46-.58.14-.09.29-.14.46-.14.24,0,.49.07.74.23l-.25.65c-.18-.1-.35-.15-.53-.15-.16,0-.3.05-.43.14-.12.09-.21.22-.27.39-.08.25-.12.52-.12.82v2.17h-.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.06,99.69v-.61c-.33.47-.78.7-1.35.7-.25,0-.49-.05-.7-.14-.22-.09-.38-.21-.49-.35-.1-.14-.18-.31-.22-.52-.03-.14-.04-.35-.04-.65v-2.56h.72v2.3c0,.37.01.62.04.74.05.18.14.33.29.43.15.1.33.16.55.16s.42-.06.61-.16c.19-.11.32-.26.4-.44.08-.19.12-.45.12-.81v-2.22h.72v4.14h-.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.84,101.27v-5.73h.66v.54c.15-.21.33-.37.52-.47.2-.11.43-.16.71-.16.36,0,.68.09.96.27.28.18.49.44.63.77.14.33.21.69.21,1.09,0,.42-.08.81-.23,1.14-.16.34-.38.6-.68.78-.3.18-.61.27-.94.27-.24,0-.46-.05-.65-.15-.19-.1-.35-.22-.47-.37v2.01h-.72ZM22.49,97.64c0,.53.11.93.33,1.18.22.26.49.38.8.38s.6-.13.82-.39c.23-.26.34-.67.34-1.23s-.11-.92-.33-1.19c-.22-.26-.49-.39-.8-.39s-.58.14-.82.42c-.24.28-.35.69-.35,1.22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.13,97.62c0-.77.22-1.34.66-1.7.37-.31.81-.46,1.34-.46.58,0,1.06.19,1.43.56.37.37.56.89.56,1.54,0,.53-.08.95-.25,1.26-.16.31-.4.54-.72.71-.31.17-.66.25-1.03.25-.6,0-1.08-.19-1.44-.56-.37-.37-.55-.91-.55-1.61M26.87,97.62c0,.53.12.93.35,1.19.24.26.54.4.9.4s.65-.13.89-.4c.24-.27.36-.67.36-1.21,0-.51-.12-.9-.36-1.16-.24-.27-.54-.4-.89-.4s-.66.13-.9.39c-.24.26-.35.66-.35,1.19"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.47,
    y: 94.13,
    width: 1.37,
    height: 6.09
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.15 100.22 35.15 94.13 36.48 94.13 39.25 98.2 39.25 94.13 40.52 94.13 40.52 100.22 39.15 100.22 36.42 96.25 36.42 100.22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.96,94.13h2.5c.56,0,.99.04,1.29.12.4.1.74.29,1.02.56.28.27.5.6.65.99.15.39.22.87.22,1.44,0,.5-.07.93-.21,1.3-.17.44-.41.8-.73,1.08-.24.21-.56.37-.96.49-.3.08-.7.13-1.21.13h-2.57v-6.09ZM43.32,95.16v4.04h1.02c.38,0,.66-.02.83-.06.22-.05.41-.13.55-.25.15-.12.27-.32.36-.59.09-.27.14-.65.14-1.12s-.05-.83-.14-1.09c-.09-.25-.22-.45-.39-.59-.16-.14-.38-.24-.63-.29-.19-.04-.56-.06-1.12-.06h-.61Z"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.74,
    y: 94.13,
    width: 1.37,
    height: 6.09
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.93 100.22 52.93 95.16 50.93 95.16 50.93 94.13 56.3 94.13 56.3 95.16 54.3 95.16 54.3 100.22"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.18 100.22 57.18 94.13 62.2 94.13 62.2 95.16 58.55 95.16 58.55 96.51 61.94 96.51 61.94 97.54 58.55 97.54 58.55 99.2 62.32 99.2 62.32 100.22"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.8 100.22 65.11 97.04 63.01 94.13 64.61 94.13 65.96 96.09 67.29 94.13 68.88 94.13 66.77 97.09 69.08 100.22 67.44 100.22 65.94 98.12 64.43 100.22"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(87.04 100.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zara.com/contact"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeneme60X402);
export default __webpack_public_path__ + "static/media/deneme60x402.5f573ab8e20372ba24c09c1ace008dd3.svg";
export { ForwardRef as ReactComponent };